import React, { useEffect } from 'react';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive } from '../../utils/EllowUtils';
import ComingSoon from '../../components/comingSoon';
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from 'react';
import Styles from "./styles.module.scss";
import { getAllocatedto, getCandidates } from '../resources/services';
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import ReferedTab from './referredTab';
import { getReferredResources, submitPaymentofReferral } from './services';
import NotificationAlert from "../../components/notification";


function ReferedCandidates() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  const BreadcrumsValues = ["Referred Candidates"]
  const loginId = localStorage.getItem('loginId')
  const [filterValues, setFilterValues] = useState<any>(null)
  const [companyName, setCompanyName] = useState<any>()
  const [rejectedData, setRejectedData] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [total, setTotal] = useState<any>()
  const [sort, setSort] = useState<any>([])
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [modal, setModal] = useState<boolean>()

  useEffect(() => {
    
    getAllResources( )
    getAllocation();
    viewedpageMixpanel();
  
  }, [])

  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const getAllResources = () => {
    let body = {
    loginId: loginId
 }
    getReferredResources(body).then((response: any) => {
      
      if (response && response.status === 1) {
        setRejectedData(response.data)
        setTotal(response.count)
      }
    })
  }

  
  
  const closeTag = (data: any) => {
    let value = {
      filters: data
    }
      applyFilter(value);
    
  }

  const applyFilter = (data: any) => {
    setFilterValues(data.filters)
  }

  const submitPayment = (data: any) => {
    if (data) {
      submitPaymentofReferral(data).then((response: any) => {
        if(response && response.status === 1){
          setModal(false)
          displayNotification("Details saved successfully")
          getAllResources()
        }
      })
    }
  }

  const displayNotification = (message: any) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 4000)
  }
  
  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'referedcandidates'} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
        //  applyResourceFilter={applyFilter}
          searchChange={'searchChange'}
          closeTag={closeTag}
          navigateTo="../createResources"
          filterValues={filterValues}
          companyName={companyName}
          type='resources'
          allocatedTo={allocatedTo}
          
        />
      <section className="contentBox">
        <div className="innerPadd24">
            <ReferedTab data={rejectedData} total={total} getTablesValues={() => getAllResources()} setSort={setSort} paymentSubmit={submitPayment} modal={modal}/>
        </div>
      </section>
      </div>
      {notification && <NotificationAlert onClose={() =>{ setNotification(false)}} closable={true} >{message}</NotificationAlert>}
    </section>
  )
}

export default ReferedCandidates